export default {"src":"/evde-internet/_next/static/media/modemIMG.e4ca3633.svg","height":84,"width":101};